import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import { PipelineWidgetConversionChart } from "./PipelineWidgetConversionChart";
import useService from "../../Hooks/useService";
import PipelineReportService from "../../../Services/PipelineReport.service";
import CustomCard from "../../UI/CustomCard/CustomCard";
import { OpportunitySourceMultiSearch } from "../../Presentational/OpportunitySource/OpportunitySourceSearch";
export const AllStagesConversionPipelineWidget = ({ pipeline, className, }) => {
    const [config, setConfig] = React.useState({
        stageOrder: pipeline.stages.map((s) => s.id),
        opportunitySources: [],
    });
    React.useEffect(() => {
        setConfig((c) => (Object.assign(Object.assign({}, c), { stageOrder: pipeline.stages.map((s) => s.id) })));
    }, [pipeline.stages]);
    const [conversionState, getConversionState] = useService(PipelineReportService.allStageConversionCounts);
    React.useEffect(() => {
        getConversionState({
            stageIds: config.stageOrder,
            opportunitySourceIds: config.opportunitySources.map((source) => source.id),
            opportunityCreatedAfter: null,
        });
    }, [getConversionState, config]);
    return (_jsx(CustomCard, { title: "All Stage Conversion", className: className, children: _jsxs("div", { className: "card-body", children: [_jsx("div", { className: "mb-3", style: { width: 400 }, children: _jsx(OpportunitySourceMultiSearch, { placeholder: "Opportunity Sources", "aria-label": "Opportunity Sources", value: config.opportunitySources, onChange: (sources) => {
                            setConfig((c) => (Object.assign(Object.assign({}, c), { opportunitySources: sources })));
                        } }) }), _jsx(ServiceResult, { loader: Loaders.overlay(), state: conversionState, children: (conversionData) => (_jsx(PipelineWidgetConversionChart, { setConfig: setConfig, config: config, conversionData: conversionData })) })] }) }));
};
